import * as SmsPermissionsAPI from 'api/sms-permissions';
import APIUtils from '@spothero/utils/api';
export const CHECKOUT_SMS_PERMISSION = 'CHECKOUT_SMS_PERMISSION';
export const CHECKOUT_UPDATE_SMS_PERMISSION = 'CHECKOUT_UPDATE_SMS_PERMISSION';
export const RESET_SMS_PERMISSIONS = 'RESET_SMS_PERMISSIONS';
export const getSMSPermissions = (phoneNumber) => (dispatch) => {
    if (!phoneNumber) {
        return {};
    }
    const permissionsLoader = APIUtils.makeCancelable(SmsPermissionsAPI.getSMSPermissions({ phoneNumber }));
    // redux-promise-middleware makes dispatch return a Promise when the
    // payload contains a `promise` property, but the Dispatch type doesn't
    // reflect this — cast to suppress the type error.
    dispatch({
        type: CHECKOUT_SMS_PERMISSION,
        payload: permissionsLoader,
    }).catch(() => { });
    return permissionsLoader;
};
export const updateSMSPermissions = ({ phoneNumber, smsPermissions, }) => (dispatch) => {
    if (!phoneNumber) {
        return {};
    }
    return dispatch({
        type: CHECKOUT_UPDATE_SMS_PERMISSION,
        payload: SmsPermissionsAPI.updateSMSPermissions({
            phoneNumber,
            smsPermissions,
        }),
    })
        .then(({ value }) => {
        if (!value || !value.id) {
            return {
                success: false,
            };
        }
        return { success: true };
    })
        .catch(() => {
        return {
            success: false,
        };
    });
};
export const resetSmsPermissions = () => ({
    type: RESET_SMS_PERMISSIONS,
});
